const KEY = 'affiliate.ref'

type RefRecord = { code: string; exp: number }

export function saveReferralCode(code: string, days = 30) {
  try {
    const exp = Date.now() + days * 24 * 60 * 60 * 1000
    const rec: RefRecord = { code: code.trim(), exp }
    localStorage.setItem(KEY, JSON.stringify(rec))
  } catch {}
}

export function getReferralCode(): string | null {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return null
    const rec = JSON.parse(raw) as RefRecord
    if (!rec?.code || !rec?.exp) return null
    if (Date.now() > Number(rec.exp)) { localStorage.removeItem(KEY); return null }
    return rec.code
  } catch { return null }
}

export function captureReferralFromLocation(loc: Location = window.location) {
  try {
    const url = new URL(loc.href)
    const code = (url.searchParams.get('ref') || url.searchParams.get('referral') || '').trim()
    if (code) saveReferralCode(code)
  } catch {}
}

